import { useEffect } from 'react';
import { useAuth } from '../../context/auth';
import { postUserSupplierAdherence } from '../../client/userAdherence/index';

export const useModuleAdherence = (moduleId) => {
  const { user } = useAuth();

  useEffect(() => {
    if (user?.id) {
      const registerAdherence = async () => {
        try {
          await postUserSupplierAdherence(user.id, moduleId);
        } catch (error) {
          console.error(`Error registrando adherencia para módulo ${moduleId}:`, error);
        }
      };

      registerAdherence();
    }
  }, [user, moduleId]);
};